export { BackgroundItem } from './BackgroundItem';
export type { BackgroundItemProps } from './BackgroundItem';
export { default } from './BackgroundItem';
